import React from 'react';

import { Translate } from 'react-localize-redux';
import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../../helpers/utilities';
import ErrorBoundary from '../../../layouts/Portal/ErrorBoundary';
import { RMSModules } from '../utils/rmsModules';
import { RMSSubscriptions } from '../utils/rmsSubscriptions';

const RMSPage = lazyWithRetry(() => import('../components/RMSPage'));

const DocumentsRoutes: React.FC<React.PropsWithChildren<RouteComponentProps>> = (
  props: RouteComponentProps
) => {
  const {
    match: { path },
  } = props;
  return (
    <ErrorBoundary identifier="documents">
      <Switch>
        <Route
          exact
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <RMSPage
                editPermissions={['EditDocumentExplorer']}
                subscription={RMSSubscriptions.DOCUMENTS}
                title={<Translate id="Documents" />}
                url={`modules/${RMSModules.DOCUMENTS}`}
                module={RMSModules.DOCUMENTS}
                includePropertyIdInUrl
                allowFranchisorLevel
              />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default DocumentsRoutes;
